import { Spinner } from "@digipost/dds-spinner-react";
import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import ErrorPage from "../ErrorPage";
import { Dispatch } from "../infrastructure/redux/actions";
import {
  organisationAction,
  RegistrationStatus,
} from "../infrastructure/redux/org/org-actions";
import { ReduxState } from "../infrastructure/redux/state.js";
import Translated from "../infrastructure/Translated";
import { useRootPath } from "../infrastructure/useRootPath";
import styles from "./Registrer.module.css";
import SelectOrganisationForm from "./select-organisation/SelectOrganisationForm";
import SigneringRegisterOrganisationForm from "./SigneringRegisterOrganisationForm";

const Registrering: FC = () => {
  const dispatch = useDispatch<Dispatch>();
  const rootPath = useRootPath();
  const navigate = useNavigate();
  const { data, solvencyOK, hasOrgs, registrationStatus } = useSelector(
    (state: ReduxState) => state.org,
  );
  const isSigneringContext = useSelector(
    (state: ReduxState) => state.app.params.mode === "signering",
  );

  useEffect(() => {
    dispatch(organisationAction());
  }, [dispatch]);

  if (registrationStatus === RegistrationStatus.FAILED) {
    navigate(`${rootPath}/bedrift/manuell`);
  }

  if (registrationStatus === RegistrationStatus.TECHNICAL_FAIL) {
    return (
      <ErrorPage>
        <Translated textKey="register.org.error.technical_error_description" />
      </ErrorPage>
    );
  }

  if (!data) {
    return <Spinner size="large" className={styles.spinner} />;
  }

  if (!solvencyOK || !hasOrgs) {
    navigate(`${rootPath}/bedrift/manuell`);
  }

  return isSigneringContext ? (
    <SigneringRegisterOrganisationForm />
  ) : (
    <SelectOrganisationForm />
  );
};

export default Registrering;
